import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sha256 } from "crypto-hash";
import { endpoint } from "../../../utils/constants/endpoint";
import { PURGE } from "redux-persist";
import client from "../../../app/core/client-http/client";
import { toast } from "react-toastify";
import { actions as appActions } from "../../../app/appSlice";

const _initialState = {
  isLoading: false,
};

export const doAdminLogin = createAsyncThunk(
  "login/admin",
  async (body, thunkAPI) => {
    body.Password = await sha256(body.Password);
    let response;
    if (body.TwoFactorCode) {
      response = await client.post(endpoint.ADMIN_ACCOUNT.GUEST_LOGIN, body); //with otp
    } else {
      response = await client.post(endpoint.ADMIN_ACCOUNT.GUEST_CODE, body); //no otp
    }
    if (response.ok) {
      if (response.data.Result === 1) {
        if (body.TwoFactorCode) {
          thunkAPI.dispatch(appActions.updateAppState(response.data));
          thunkAPI.dispatch(appActions.setRstPasswordRequired(response.data));
        }
        return thunkAPI.fulfillWithValue(response.data);
      } else if (response.data.Result === 2 || response.data.Result === 11) {
        toast.error("Informazioni inserite non corrette");
        return thunkAPI.rejectWithValue();
      } else {
        toast.error("Informazioni inserite non corrette");
        return thunkAPI.rejectWithValue();
      }
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const doUserLogin = createAsyncThunk(
  "login/user",
  async (body, thunkAPI) => {
    body.Password = await sha256(body.Password);

    const response = await client.post(endpoint.USERS.GUEST_LOGIN, body);
    if (response.ok) {
      if (response.data.Result === 1) {
        response.data.Data = { ...response.data.Data, Role: "user" };
        response.data.Data.AccessToken = response.data.Data.Token;
        thunkAPI.dispatch(appActions.updateAppState(response.data));
        thunkAPI.dispatch(appActions.setRstPasswordRequired(response.data));
        return thunkAPI.fulfillWithValue(response.data);
      } else if (response.data.Result === 2 || response.data.Result === 11) {
        toast.error("Informazioni inserite non corrette");
        return thunkAPI.rejectWithValue();
      } else {
        console.error(response.data);
        toast.error("Informazioni inserite non corrette");
        return thunkAPI.rejectWithValue();
      }
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const doGetDataHome = createAsyncThunk(
  "login/get-dataHome",
  async ({ token }, thunkAPI) => {
    const response = await client.get(endpoint.USER_DATA.DATA_HOME, null, {
      extraHeader: {
        key: "Authorization",
        value: `Bearer ${token}`,
      },
    });
    if (response?.data?.Data?.employmentStatusId) {
      const employmentTypes = await client.get("Data/employmenttypes", null, {
        extraHeader: {
          key: "Authorization",
          value: `Bearer ${token}`,
        },
      });
      const languageKey = employmentTypes?.data?.Data.find(
        (element) => element.id === response.data.Data.employmentStatusId
      )?.languageKey;
      thunkAPI.dispatch(
        appActions.setEmploymentTypeLanguageKey({
          languageKey: languageKey,
        })
      );
    }
    if (response.data.Data.studioId) {
      thunkAPI.dispatch(
        appActions.setStudioId({
          studioId: response.data.Data.studioId,
        })
      );
      thunkAPI.dispatch(
        appActions.setLogoImageURL({
          logoImageURL: response.data.Data.commLogoURL,
        })
      );
    }
    if (response.data.Data.primaryColor && response.data.Data.secondaryColor)
      return thunkAPI.dispatch(
        appActions.setColors({
          primaryColor: response.data.Data.primaryColor,
          secondaryColor: response.data.Data.secondaryColor,
        })
      );
    // return response;
  }
);

export const doGetStudioById = createAsyncThunk(
  "login/get-studio-by-id",
  async ({ studioId, token }, thunkAPI) => {
    const response = await client.get(
      endpoint.ADMIN_STUDIO.STUDIO + "/" + studioId,
      null,
      {
        extraHeader: {
          key: "Authorization",
          value: `Bearer ${token}`,
        },
      }
    );
    thunkAPI.dispatch(
      appActions.setLogoImageURL({
        logoImageURL: response.data.Data.logoImageUrl,
      })
    );
    if (response.data.Data.primaryColor && response.data.Data.secondaryColor)
      return thunkAPI.dispatch(
        appActions.setColors({
          primaryColor: response.data.Data.primaryColor,
          secondaryColor: response.data.Data.secondaryColor,
        })
      );
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: _initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doAdminLogin.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(doAdminLogin.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(doAdminLogin.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(doUserLogin.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(doUserLogin.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(doUserLogin.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(PURGE, (state) => {
        state = _initialState;
        return state;
      });
  },
});

export const { name, reducer, actions } = loginSlice;
